import { StoreItemImage } from '@givebacks/api/store';
import { useFormListValidation } from 'core';
import { Modal } from 'ui';
import { UseFormReturnType } from 'ui/Form';

import {
  BannerImageForm,
  BannerImageFormType,
} from '../../../molecules/forms/EditPeerPage/BannerImageForm/BannerImageForm';
import { EditPeerPageModalFooter } from './EditPeerPageModalFooter';
import {
  ModalTitleWithBackButton,
  useEditPeerPageModalProvider,
} from './EditPeerPageModalProvider';

const EditBannerImageModalFooter = ({ peerImage }: { peerImage?: StoreItemImage }) => {
  const { useGetForm } = useFormListValidation<{
    bannerImage: UseFormReturnType<BannerImageFormType>;
  }>();

  const form = useGetForm('bannerImage');

  return (peerImage || form?.values?.file) && <EditPeerPageModalFooter />;
};

const EditBannerImageModal = () => {
  const { opened, close, meta } = useEditPeerPageModalProvider({
    id: 'bannerImage',
  });

  return (
    <Modal
      opened={opened}
      onClose={close}
      title={<ModalTitleWithBackButton>Banner Image</ModalTitleWithBackButton>}
    >
      <BannerImageForm initialValue={meta.peer.image} />
      <EditBannerImageModalFooter peerImage={meta.peer.image} />
    </Modal>
  );
};

export { EditBannerImageModal };
